import { render, staticRenderFns } from "./zsmglDetail.vue?vue&type=template&id=589fa276&scoped=true&"
import script from "./zsmglDetail.vue?vue&type=script&lang=js&"
export * from "./zsmglDetail.vue?vue&type=script&lang=js&"
import style0 from "./zsmglDetail.vue?vue&type=style&index=0&id=589fa276&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589fa276",
  null
  
)

export default component.exports